import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { CustomButton } from '../../../_common';
import './ErrorActiveModal.scss';
interface ErrorDispatchModalProps {
    onClickHide: () => void;
    show: boolean;
    textMessage: string;
}

const ErrorActiveModal = ({ show, onClickHide, textMessage }: ErrorDispatchModalProps): React.ReactElement => {
    return (
        <Modal show={show} onHide={onClickHide} backdrop="static">
            <Modal.Header className="ErrorModal-Header">
                <Modal.Title className="ErrorModal-Header-Container">
                    <i className="material-icons ErrorModal-X-Button" onClick={onClickHide}>
                        close
                    </i>
                    <div className="ErrorModal-Title">Edit Load Summary</div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="ErrorModal-Body">
                <div>{textMessage}</div>
            </Modal.Body>
            <Modal.Footer>
                <div style={{ width: '100 px' }}>
                    <CustomButton title="OK" isDisabled={false} onClick={onClickHide}></CustomButton>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ErrorActiveModal;
